// export const contactObj = {
// 	Tiktok: "https://www.tiktok.com/@fancymartin7?_t=8pxS3FQTdrK&_r=1",
// 	Linkedin: "https://www.linkedin.com/in/long-sheng-81763b26a/",
// 	Youtube: "https://www.youtube.com/@longsheng2019",
// 	Twitter: "https://twitter.com/longsheng2019",
// 	Pinterest: "https://www.pinterest.com/longshengmfg/",
// 	FaceBook: "https://www.facebook.com/profile.php?id=61558577050675",
// };
export const contactObj = {
	Tiktok: "https://www.tiktok.com/@stary7788",
	Linkedin: "https://www.linkedin.com/",
	Youtube: "https://www.youtube.com/@STARYLLC",
	Twitter: "https://twitter.com/",
	Pinterest: "https://www.pinterest.com/",
	FaceBook: "https://www.facebook.com/",
	Instagram: "https://www.instagram.com/stary_llc/",
	Whatsapp: "https://wa.me/17403507878",
};

export const contactInfo = {
	email: "marketing@staryline.com",
	phone: "+1 7403507878",
	whatsapp: "+1 7403507878",
	wechat: "1174025290",
	address: "1020 Luxe Ave, Columbus, Ohio,43220",
	name: "STARY LLC Co., Ltd.",
};
